import { render, staticRenderFns } from "./AccountingPayslips.vue?vue&type=template&id=09e0c5ce"
import script from "./AccountingPayslips.vue?vue&type=script&lang=js"
export * from "./AccountingPayslips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports